<template>
 <v-container class="grey lighten-5" style="min-height:100%;padding-bottom:200px">



    <v-snackbar
      v-model="toast"
      timeout="2000"
      color="green"
    >
   بروزرسانی با موفقیت انجام شد

    </v-snackbar>
       <v-overlay :value="loading">
      <v-progress-circular style="transform: translateX(-15px);"
        indeterminate
        size="30"
      ></v-progress-circular>
      <p style="text-align: center;
    margin: 10px 0;
    transform: translateX(15px);">لطفا صبر کنید</p>
    </v-overlay>
    <v-row>

        <v-col cols="12" sm="12" class="py-0 px-0" >

             <v-tabs v-model="tab" background-color="#eee"  >
      <v-tab>
        اطلاعات تجاری
      </v-tab>
         <v-tab>
         مدارک 
      </v-tab>
       <v-tab v-if="branding.device_activity.length > 0 && false">
         برند و دستگاه ها 
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>




        <v-card flat>


          <v-card-text>

               <v-alert v-if="user.can_edit == 0" dense color="orange" text>
در حال حاضر قادر به ویرایش همه اطلاعات نیستید
<br>
لطفا از قسمت پشتیبانی پیگیری کنید
</v-alert>

               <v-alert v-if="branding.brand_accepted == 1" dense
  color="orange" text
>
در انتظار تایید اطلاعات تجاری
</v-alert>
  <v-alert v-if="branding.brand_accepted != 0 && branding.brand_accepted != 1 && branding.brand_accepted != 2" dense
  text color="orange"
>
{{branding.brand_accepted}}
</v-alert>
  <v-alert v-if="branding.brand_accepted == 2" dense
  color="green" text
>
     اطلاعات تجاری شما تایید 
</v-alert>


                  <v-select
                  v-model="branding.province_id"
                  :loading="provinces.length == 0"
                  :disabled="user.can_edit == 0 && user.role != 'admin'"
          :items="provinces"
          item-text="name"
          item-value="id"
          label="استان یا منطقه"
          outlined
        ></v-select>



    <v-select
    :disabled="!branding.province_id || (user.can_edit == 0 && user.role != 'admin')"
      v-model="branding.cities"
    
      :items="cities"
      item-text="name"
          item-value="id"
      label="شهرها و مناطق تحت پوشش"
      multiple
      outlined
      
    >
    </v-select>

           <v-select
            :disabled="user.can_edit == 0 && user.role != 'admin'"
           :loading="cats.length == 0"
           v-model="branding.cat_id"
          :items="cats"
           item-text="name"
          item-value="id"
          label="حوزه کاری"
          outlined
        ></v-select>


   <v-select v-if="branding.cat_id"
   multiple
    :disabled="user.can_edit == 0 && user.role != 'admin'"
           :loading="cats_devices.length == 0"
           v-model="branding.device_activity"
          :items="cats_devices"
           item-text="name"
          item-value="id"
          label="در چه دستگاه هایی فعالیت می کنید؟"
          outlined
        ></v-select>

        
  <v-radio-group
   :disabled="user.can_edit == 0 && user.role != 'admin'"
   v-model="branding.user_type" class="mt-0" >
      <template v-slot:label>
        <div class="text-right">نوع فعالیت</div>
      </template>
      <v-radio  value="1">
        <template v-slot:label>
          <div>حقیقی <span class="text-caption">تعمیرکار هستم و برای خودم کار میکنم</span></div>
        </template>
      </v-radio>
      <v-radio value="2">
        <template v-slot:label>
         <div>تجاری <span class="text-caption">صاحب کسب و کار هستم </span></div>
        </template>
      </v-radio>
    </v-radio-group>

   <v-text-field  :disabled="user.can_edit == 0 && user.role != 'admin'"
v-model="branding.name" v-if="branding.user_type == 1"
            label="نام و نام خانواگی تعمیرکار"
            outlined
          ></v-text-field>

 <v-text-field
  :disabled="user.can_edit == 0 && user.role != 'admin'"
  v-model="branding.name" v-if="branding.user_type == 2"
            label="نام برند   "
            outlined
          ></v-text-field>


 <v-text-field

 v-model="branding.mobile1" v-if="branding.user_type != 0"
            label=" شماره تلفن همراه 1   "
            outlined
            hint="از این شماره برای ارتباط واتساپ و تلگرام هم استفاده می شود"
            persistent-hint
            type="tell"
            class="ltr"
          ></v-text-field>
          <br>
 <v-text-field
  v-model="branding.mobile2" v-if="branding.user_type != 0"
            label=" شماره تلفن همراه 2   "
            outlined
            type="tell"
            class="ltr"
          ></v-text-field>

 <v-text-field
   v-model="branding.phone1" v-if="branding.user_type != 0"
            label=" شماره تلفن ثابت 1   "
            outlined
            type="tell"
            class="ltr"
          ></v-text-field>
 <v-text-field    v-model="branding.phone2" v-if="branding.user_type != 0"
            label=" شماره تلفن ثابت 2   "
            outlined
            type="tell"
            class="ltr"
          ></v-text-field>
 <v-text-field    v-model="branding.postal_code" v-if="branding.user_type == 2"
            label="کد پستی محل کار"
            outlined
            class="ltr"
          ></v-text-field>
 <v-text-field v-model="branding.address" v-if="branding.user_type == 2"
            label="آدرس محل کار"
            outlined
          ></v-text-field>
            <v-textarea v-model="branding.description" v-if="branding.user_type != 0"
          outlined
          label="توضیحات"
          value=""
        ></v-textarea>

          </v-card-text>
        </v-card>
      </v-tab-item>
        <v-tab-item>
        <v-card flat>
          <v-card-text>
              <v-row>
<v-col cols="7">
    
<label  :disabled="user.can_edit == 0 && user.role != 'admin'" class="input" for="nationalimage"  v-ripple >
تصویر کارت ملی
</label>


<v-file-input   ref="nationalimage"  @change="pic_change(1,$event)" v-model="nationalimage" style="display:none" id="nationalimage" ></v-file-input>
</v-col>
<v-col cols="5">
  
<v-img 
  max-height="150" max-width="100%" class="uploaded-pic" 
:src="national_pic==''?branding.national_image:national_pic"
></v-img>
</v-col>
             
<v-alert v-if="branding.national_pic_accepted == 1" dense
  color="orange" text
>
در انتظار تایید  تصویر کارت ملی 
</v-alert>
  <v-alert v-if="branding.national_pic_accepted != 0 && branding.national_pic_accepted != 1 && branding.national_pic_accepted != 2" dense
  color="orange" text
>
{{branding.national_pic_accepted}}
</v-alert>
  <v-alert v-if="branding.national_pic_accepted == 2" dense color="green" text>
 تصویر کارت ملی شما تایید شد
</v-alert>




              </v-row>
              <br>
                <v-divider ></v-divider>
  <br>

        <v-row>
<v-col cols="7">
    
<label class="input" for="logo_pic"  v-ripple >
تصویر کاربر یا لوگو تجاری 
</label>
<v-file-input ref="logo_pic" @change="pic_change(2,$event)" v-model="logoimage" style="display:none" id="logo_pic" ></v-file-input>
</v-col>
<v-col cols="5">
  
<v-img
  max-height="150"
  max-width="100%"
    class="uploaded-pic"
:src="logo_pic==''?branding.logo_image:logo_pic"
></v-img>
</v-col>

<v-alert v-if="branding.profile_pic_accepted == 1" dense
  color="orange" text
>
در انتظار تایید  تصویر  کاربر یا لوگو 
</v-alert>
  <v-alert v-if="branding.profile_pic_accepted != 0 && branding.profile_pic_accepted != 1 && branding.profile_pic_accepted != 2" dense
  color="orange" text
>
{{branding.profile_pic_accepted}}
</v-alert>
  <v-alert v-if="branding.profile_pic_accepted == 2" dense
  color="green" text
>
 تصویر  کاربر یا لوگو شما تایید شد
</v-alert>


              </v-row>
              <br>
                <v-divider ></v-divider>
  <br>
  <v-row>
<v-col cols="7">
    
<label :disabled="user.can_edit == 0 && user.role != 'admin'" class="input" for="agreement_pic"  v-ripple >
تصویر قرار داد مرکز تعمیرات ایران
</label>
<v-btn style="width:100%" @click="download()" class="my-2"
  elevation="0"
> دریافت تصویر قرارداد</v-btn>

<v-file-input ref="agreement_pic" @change="pic_change(3,$event)" v-model="agreementimage" style="display:none" id="agreement_pic" ></v-file-input>
</v-col>
<v-col cols="5">
 

<v-img
  max-height="150"
  max-width="100%"
    class="uploaded-pic"
:src="agreement_pic==''?branding.agreement_image:agreement_pic"
></v-img>
</v-col>

            <v-alert v-if="branding.agreement_accepted == 1" dense
  color="orange" text
>
در انتظار تایید  تصویر    قرارداد 
</v-alert>
  <v-alert v-if="branding.agreement_accepted != 0 && branding.agreement_accepted != 1 && branding.agreement_accepted != 2" dense
  color="orange" text
>
{{branding.agreement_accepted}}
</v-alert>
  <v-alert v-if="branding.agreement_accepted == 2" dense
  color="green" text
>
 تصویر    قرارداد شما تایید شد
</v-alert>
              </v-row>
            



                <v-divider ></v-divider>
  <br>
       <v-row>
        

<v-col cols="7">
    
<label :disabled="user.can_edit == 0 && user.role != 'admin'" class="input" for="evidenceimage"  v-ripple >
تصویر    مدرک فنی حرفه ای 
</label>
<v-file-input ref="evidenceimage" @change="pic_change(4,$event)" v-model="evidenceimage" style="display:none" id="evidenceimage" ></v-file-input>
</v-col>
<v-col cols="5">
<v-img
  max-height="150"
  max-width="100%"
    class="uploaded-pic"
    :src="evidence_pic==''?branding.evidence_image:evidence_pic"

></v-img>
</v-col>
            <v-alert v-if="branding.evidence_accepted == 1" dense
  color="orange" text
>
در انتظار تایید  تصویر مدرک فنی حرفه ای 
</v-alert>
  <v-alert v-if="branding.evidence_accepted != 0 && branding.evidence_accepted != 1 && branding.evidence_accepted != 2" dense
  color="orange" text
>
{{branding.evidence_accepted
}}
</v-alert>
  <v-alert v-if="branding.evidence_accepted == 2" dense
  color="green" text
>
 تصویر    مدرک فنی و حرفه ای شما تایید شد
</v-alert>

              </v-row>



          </v-card-text>
        </v-card>
      </v-tab-item>
        <v-tab-item>
        <v-card flat>
          <v-card-text>

        

                  <v-select class="main-brand-select"
   v-model="brands"
       :loading="$store.state.brands == 0"
      :items="$store.state.brands"
      label="برندهای قابل پشتیبانی"
       item-text="name"
          item-value="id"
      multiple
      outlined
    >
    </v-select>



                 <v-select
   v-for="(device,index) in brands" :key="index"
   v-model="selected_devices[index]"
   @change="device_changed(device,$event)"
      :items="get_device_list(device)"
      :label="' دستگاه های پشتیبانی ' + get_device_name(device)"
            item-text="name"
          item-value="id"
      multiple
      outlined
    >
    </v-select>

          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>


      

        </v-col>
    </v-row>

    <v-footer
 fixed
   padless

      flat
      class="bottom-navigation"
      color="white"
      dark
      style="bottom:60px"
    >
    <v-btn
    @click="save()"
  block
  large
  color="secondary"
  tile
>ذخیره اطلاعات</v-btn>
    </v-footer>
 </v-container>
</template>

<script>
  export default {
methods:{
  download(){
var url = 'https://iranrepaircenter.ir/panel/api/uploads/rules.pdf';
 const toDataURL = url => fetch(url)
        .then(response => response.blob())
        .then(blob => new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result)
          reader.onerror = reject
          reader.readAsDataURL(blob)
        }))
      
      
      toDataURL(url)
        .then(dataUrl => {
         var link = document.createElement('a');
            link.download = url.split("/").pop();
            link.href = dataUrl;
            link.click();
        })

  },
  device_changed(device,$event){
this.$store.state.brands_changes.forEach((element,index) => {
if(element.id == device){
  this.$store.state.brands_changes[index]['devices'] = $event
  
}
})
  },
  save(){
    const _this = this;

_this.loading = true
var uploaded = 2;
var uploaded_complete = 0;
    this.files.forEach((element,index) => {
    
       if(element != ''){
uploaded++;
    var formData = new FormData();
 formData.append('file', this.files[index]);
var root = ''
switch (index) {

  case 0:  
  root = 'nationals'
    this.$store.state.user_branding_changes.national_pic_accepted = 1
  break;
   case 1:  root = 'logos';
    this.$store.state.user_branding_changes.profile_pic_accepted = 1
   
   break;
    case 2:  root = 'agreements';
     this.$store.state.user_branding_changes.agreement_accepted = 1
    break;
     case 3:  root = 'evidences'; 
     this.$store.state.user_branding_changes.evidence_accepted = 1
     break;

  default:
    break;
}

console.log(formData,root,_this.branding.id)

     _this.api_upload(formData,root,_this.branding.id).then(() => {
_this.files[index] = '';
uploaded_complete++;
     })




// formData.append('data', JSON.stringify({ type: index,actions: ['upload']}));

 
       }
    });


    var timeout = setInterval(function () {
  if(uploaded == uploaded_complete){

    uploaded = 2;


    uploaded_complete = 0
    _this.toast = true;
    _this.loading = false
 clearInterval(timeout);
  }
}, 300);



senddata = {data: {  data: ['delete', 'agent_branding_brands',{branding_id:_this.branding.id}] } , actions: ['insert'] };
 _this.api_get(senddata).then(() => {
uploaded_complete++;

_this.brands.forEach(element => {
  uploaded++;
    var devices = _this.$store.state.brands_changes.filter(
      brand => brand.id === element);
      devices = devices[0].devices.toString()
      senddata = {data: {  data: ['insert', 'agent_branding_brands',
      {branding_id:_this.branding.id,brand_id:element,'devices':devices}] } , actions: ['insert'] };

 _this.api_get(senddata).then(() => {

uploaded_complete++;
 })
});


 })




   var senddata = {  data: {  data: ['update', 'agent_branding',
    {
      name:this.branding.name,
      province_id:this.branding.province_id,
      device_activity: JSON.stringify(this.branding.device_activity),
      cat_id:this.branding.cat_id,
      cities:this.branding.cities.toString(),
      user_type:this.branding.user_type,
      mobile1:this.branding.mobile1,
      mobile2:this.branding.mobile2,
      phone1:this.branding.phone1,
      phone2:this.branding.phone2,
      postal_code:this.branding.postal_code,
      address:this.branding.address,
      description:this.branding.description,
      national_pic_accepted : this.branding.national_pic_accepted,
      profile_pic_accepted : this.branding.profile_pic_accepted,
      agreement_accepted : this.branding.agreement_accepted,
      evidence_accepted : this.branding.evidence_accepted,
      brand_accepted : 1
    },{id: this.branding.id}
    ]}, actions: ['insert'] };
    console.log(senddata)
     this.api_get(senddata).then(() => {
uploaded_complete ++
     })
  },
  get_device_list(device){

    

var brands =  this.$store.state.brands_category.filter(
          cat => cat.brand_id == device);
      
    let result = brands.map(a => a.cat_id);

  var cats =  this.$store.state.cats.filter(
      cat => result.includes(cat.id) && this.branding.device_activity.includes(cat.id));

      return cats;
  },
  get_device_name(brand){
  var this_brand =  this.$store.state.brands.filter(
          brands => brands.id == brand);
    if(this_brand.length > 0){
return this_brand[0]['name'];
    }
      
},





pic_change(type,$event){
  
if(type == 1){
  this.national_pic= URL.createObjectURL(this.nationalimage) 
   this.files[0] = $event;

  }
if(type == 2){
  this.logo_pic= URL.createObjectURL(this.logoimage) 
  this.files[1] = $event;
 
  }
if(type == 3){
  this.agreement_pic= URL.createObjectURL(this.agreementimage) 
  this.files[2] = $event;
 
  }
if(type == 4){
  this.evidence_pic= URL.createObjectURL(this.evidenceimage) 
  this.files[3] = $event;
  
  }

}
},
 mounted(){
   const _this = this
   var senddata;


   if(this.$store.state.cats.length == 0){
      senddata = {  data: {  data: ['select', 'category', '*'] }, actions: ['get'] };
     this.api_get(senddata).then(data => {
_this.$store.state.cats = data.data
     })
   }


      senddata = {  data: {  data: ['select', 'brands', '*'] }, actions: ['get'] };
     this.api_get(senddata).then(data => {
       
          data.data.forEach(element => {
         element['devices'] = []
       });

         senddata = {data: {  data: ['select', 'agent_branding_brands', '*',{branding_id:this.branding.id}] } , actions: ['get'] };
    _this.api_get(senddata).then(result => {
      
result.data.forEach((element,index) => {
        data.data.forEach((e,i) => {
 if(element.brand_id == e.id){
console.log(result.data[index]['devices'])
  data.data[i]['devices'] = result.data[index]['devices'].split(',')
_this.selected_devices[index] = data.data[i]['devices']
}
});
})

_this.$store.state.agent_brands = result.data;
_this.$store.state.agent_brands_changes = result.data;

if(_this.$store.state.agent_brands_changes.length > 0){
 _this.brands = _this.$store.state.agent_brands_changes.map(a => a.brand_id);
}

setTimeout(function(){ 
_this.$store.state.brands = data.data
_this.$store.state.brands_changes = data.data
 }, 100);

    })

     })


   if(this.$store.state.brands_category.length == 0){
      senddata = {  data: {  data: ['select', 'brands_category', '*'] }, actions: ['get'] };
     this.api_get(senddata).then(data => {
_this.$store.state.brands_category = data.data
     })
   }



      },
 computed: {


      provinces () {
        if(this.$store.state.cities.length > 0){
  return this.$store.state.cities.filter(
          city => city.parent == 0);
        }else{
          return []
        }
  
      },
       cats () {
    return this.$store.state.cats.filter(
          cat => cat.parent == 0);
      },
        cats_devices () {
    return this.$store.state.cats.filter(
          cat => cat.parent == this.branding.cat_id);
      },
         cities () {
    return this.$store.state.cities.filter(
          city => parseInt(city.parent) == parseInt(this.branding.province_id));
      },
          user (){  
         return this.$store.state.user_changes
         },
      
       branding (){
   return this.$store.state.user_branding_changes;
 },
    },

  
    data () {
      return {
        loading:false,
        toast:false,
 files : ['','','',''],
        national_pic : '',
        nationalimage : [],
        logo_pic : '',
logoimage : [],
agreement_pic : '',
agreementimage : [],
evidence_pic : '',
evidenceimage : [],
selected_devices : [],
        name : '',
        brands : [],
brand: '',
mobile1: '',
mobile2: '',
phone1: '',
phone2: '',
postal_code: '',
address: '',
description: '',
        province : -1,

        city : [],
        cat : -1,
      
        tab: null,
      }
    },
  }
</script>
